import { useManageIndication_SetAllocationRankingOnOfferingMutation } from '../graphql/__generated__';

export const useSetAllocationRankingOnOfferingMutation = (
  options: Parameters<typeof useManageIndication_SetAllocationRankingOnOfferingMutation>[0]
) => useManageIndication_SetAllocationRankingOnOfferingMutation(options);
